export const brl = (n: number) => n.toLocaleString('pt-BR');

// "R$ 1.234,56". Aceita o Decimal serializado como string pelo backend; nulo vira R$ 0,00.
export const moedaBR = (valor?: string | number | null) =>
  `R$ ${Number(valor ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
